import React, { useState } from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import translate from '../../other/translate.json'

export default function SearchErr(props) {
  let lang = localStorage.getItem('language') || 'Ru'
  const classes = useStyles();

  return (
    <Grid container direction="column" justify="center" alignItems="center" style={{ padding: '38px 0' }}>
      <Grid item>
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0)">
            <path d="M43.5 80C62.0015 80 77 76.6421 77 72.5C77 68.3579 62.0015 65 43.5 65C24.9985 65 10 68.3579 10 72.5C10 76.6421 24.9985 80 43.5 80Z" fill="#E9ECFA" />
            <path d="M1 61C1.55228 61 2 60.5523 2 60C2 59.4477 1.55228 59 1 59C0.447715 59 0 59.4477 0 60C0 60.5523 0.447715 61 1 61Z" fill="#EB505E" />
            <path d="M78 11C78.5523 11 79 10.5523 79 10C79 9.44772 78.5523 9 78 9C77.4477 9 77 9.44772 77 10C77 10.5523 77.4477 11 78 11Z" fill="#EB505E" />
            <circle cx="40" cy="34" r="32" stroke="#3C3C56" strokeWidth="4" />
            <path d="M62.5 57L76 70.5" stroke="#3C3C56" strokeWidth="4" strokeLinecap="round" />
            <path d="M37 30C37.5523 30 38 29.5523 38 29C38 28.4477 37.5523 28 37 28C36.4477 28 36 28.4477 36 29C36 29.5523 36.4477 30 37 30Z" fill="#3C3C58" />
            <path d="M43 30C43.5523 30 44 29.5523 44 29C44 28.4477 43.5523 28 43 28C42.4477 28 42 28.4477 42 29C42 29.5523 42.4477 30 43 30Z" fill="#3C3C58" />
            <path d="M35.5 36.5C37.75 36.5 44.5 36.5 44.5 36.5" stroke="#3C3C56" strokeWidth="3" strokeLinecap="round" />
            <path opacity="0.2" d="M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9Z" fill="#3C3C58" />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="80" height="80" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </Grid>

      <Grid item style={{ marginTop: 7 }}>
        <Typography className={classes.Title3}>{translate.ErrorPages[`WereSorry${lang}`]} <br /> {translate.ErrorPages[`NothingFound${lang}`]}</Typography>
      </Grid>

      <Grid item style={{ marginTop: 16 }}>
        <Typography className={classes.Body1}>{translate.ErrorPages[`TryChangingSearch${lang}`]} <br /> {translate.ErrorPages[`ContactUs${lang}`]} catalog@cft.ru</Typography>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(theme => ({
  Title3: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '32px',
    textAlign: 'center',
    color: '#24262A'
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center',
    color: '#8987A2'
  }
}));